import hexToRgb from '@web/utils/hexToRgb';

// IMPORTANT: Keep this logic in sync with the backend logic in
// app/Support/MicrositeBackground.php.
// If one side changes without the other, microsite page load can flash
// mismatched colors before Vue hydrates.
export default function (hex: string): string[] {
  const [r, g, b] = hexToRgb(hex);

  const clamp = (v: number) => Math.min(255, Math.max(0, v));
  const toHex = (v: number) => v.toString(16).padStart(2, '0');
  const rgbToHex = (r: number, g: number, b: number) =>
    `#${toHex(clamp(r))}${toHex(clamp(g))}${toHex(clamp(b))}`;

  const lighten = (v: number, amt: number) => clamp(v + amt);
  const darken = (v: number, amt: number) => clamp(v - amt);

  // Hand-picked value to make gradients look good with most colors.
  const amt = 100;

  // Workaround for white color, which would otherwise produce a flat white gradient.
  if (r === 255 && g === 255 && b === 255) {
    return [hex, rgbToHex(darken(r, amt), darken(g, amt), darken(b, amt))];
  }

  return [hex, rgbToHex(lighten(r, amt), lighten(g, amt), lighten(b, amt))];
}
